import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../models/paginated.response.model';
import {PaycardListModel} from './paycard.list.model';
import {PaycardModel} from './paycard.model';
import {PaycardStatusEnum} from './paycard.status.enum';

@Injectable({
  providedIn: 'root'
})
export class PaycardService {
  constructor(private http: HttpClient) {
  }

  getPaginated(page: number, size: number, paycardId: string, status: PaycardStatusEnum): Observable<PaginatedResponseModel<PaycardListModel>> {
    const params: {
      page: string,
      size: string,
      paycardId?: string,
      status?: PaycardStatusEnum
    } = {
      page: page.toString(),
      size: size.toString(),
    };
    if (paycardId) { params.paycardId = paycardId; }
    if (status) { params.status = status; }

    return this.http.get<PaginatedResponseModel<PaycardListModel>>(`/v2/admin/card`, { params });
  }

  getDetailsById(paycardId: string): Observable<PaycardModel> {
    return this.http.get<PaycardModel>(`/v2/admin/card/${paycardId}`);
  }

  deleteById(paycardId: string): Observable<void> {
    return this.http.delete<void>(`/v2/admin/card/${paycardId}`);
  }

  resetPinById(paycardId: string): Observable<PaycardListModel> {
    return this.http.post<PaycardListModel>(`/v2/admin/card/${paycardId}/reset`, null);
  }
}
